import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const QueryStringParser = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [qs, setQs] = useState('');
  const [res, setRes] = useState<any>(null);

  const calculate = () => {
    try {
      const params = new URLSearchParams(qs.startsWith('?') ? qs : '?' + qs);
      const data: any = {};
      params.forEach((v, k) => { data[k] = v; });
      setRes(data);
      onResultChange(Object.entries(data).map(([k, v]) => ({ label: k, value: v as string })));
    } catch (e) {
      setRes({ error: 'Inválido' });
    }
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <FormField label="Query String" value={qs} onChange={setQs} type="textarea" placeholder="?a=1&b=2..." />
        <div className="flex justify-center my-6">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold flex items-center gap-2"><Icon name="play" className="w-5 h-5" /> Parsear</button>
        </div>
        {res && !res.error && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {Object.entries(res).map(([k, v]) => (
              <div key={k} className="p-3 bg-theme-input rounded-lg border border-theme-border font-mono text-sm">
                <span className="font-bold text-indigo-600">{k}:</span> {v as string}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default QueryStringParser;
